import { render, staticRenderFns } from "./VehicleDashboard.vue?vue&type=template&id=28d5d8e0&scoped=true&"
import script from "./VehicleDashboard.vue?vue&type=script&lang=ts&"
export * from "./VehicleDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleDashboard.vue?vue&type=style&index=0&id=28d5d8e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d5d8e0",
  null
  
)

export default component.exports